export default "__VITE_ASSET__B3UiUc2R__"